<div class="basic-card">
    <ng-container *ngIf="typeListCard; else basic">
        <flame-list-card-item [type]="typeListCard">
            <ng-container *ngTemplateOutlet="content" />
        </flame-list-card-item>
    </ng-container>
</div>
<ng-template #basic>
    <ng-container *ngTemplateOutlet="content" />
</ng-template>

<ng-template #content>
    <section class="content" [ngClass]="{'-none': !typeListCard}">
        <div 
            class="icon" 
            *ngIf="picture.type === typePicture.icon || picture.type === typePicture.img"
            [ngClass]="{'-secondary': picture.type === typePicture.img}"
        >
            <flame-icon [svgIcon]="picture.value" *ngIf="picture.type === typePicture.icon" />
            <img [src]="picture.value" alt="logo" *ngIf="picture.type === typePicture.img">
        </div>
        <flame-card [imageId]="picture.value || '12345678900'" size="s" orientation="vertical" *ngIf="picture.type === typePicture.card" />
        <div class="body">
            <ng-content />
        </div>
    </section>
</ng-template>